import {
	getOriginTaFromUrl,
	selectTerminologyFromLocation
} from '@templates/components/structures/select-ta';

const HIERARCHY_SELECTOR = '#hierarchy .card.details';

function showAllChildren(nodeElement, showBtn, hideBtn) {
	nodeElement.children.forEach(function (element) {
		element.classList.remove('d-none');
	});

	showBtn.classList.add('d-none');
	hideBtn.classList.remove('d-none');
}

function showEightChildren(nodeElement, showBtn, hideBtn, details) {
	nodeElement.children.forEach(function (element) {
		if (element.dataset.childrenindex > 8) {
			element.classList.add('d-none');
		}
	});
	showBtn.classList.remove('d-none');
	hideBtn.classList.add('d-none');
	details.style.height = 'auto';
}

imaios.pubsub.subscribe(imaios.pubsub, 'hierarchy-created', function (parentElement) {
	const entries = Array.from(parentElement.querySelectorAll('.details'));

	entries.forEach(function (element) {
		try {
			const structureChildren = element.querySelector('.list-children-hierarchy');
			if (structureChildren.children.length > 8) {
				const showMoreBtn = element.querySelector('.hierarchy-see-more');
				const showLessBtn = element.querySelector('.hierarchy-see-less');
				showMoreBtn.addEventListener('click', function () {
					showAllChildren(structureChildren, showMoreBtn, showLessBtn);
				});

				showLessBtn.addEventListener('click', function () {
					showEightChildren(structureChildren, showMoreBtn, showLessBtn, element);
				});
			}
		}
		catch (err) {
			console.error(err);
		}
	});
});

// Ugly, but we need to wait that the feature "bootstrap-collapse" has been loaded and initialized
export function autoOpenHierarchyByLocation() {
	const originTa = parseInt(getOriginTaFromUrl());
	const elementToSelect = document.querySelector(`${HIERARCHY_SELECTOR}[data-ta="${originTa}"] .collapse`);
	// Do not select the hierarchy if it is already select, or it doesn't exist
  if (!elementToSelect || elementToSelect.classList.contains("show")) {
		return;
	}
  void selectTerminologyFromLocation(
    `${HIERARCHY_SELECTOR}[data-ta="${parseInt(getOriginTaFromUrl())}"] a`
  );
}

window.addEventListener("load", () => {
  autoOpenHierarchyByLocation();
});

imaios.pubsub.publish('hierarchy-created', document.getElementById('structures-hierarchy-list'));
